import { footerLinkStyle, linkStyle } from "@/styles/sharedStyle";
import { Font, Icon } from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";
import { cursorTo } from "readline";

type Props = { regist?: boolean };

export const PrivacyPolicyLink = (props: Props) => {
  return (
    <>
      <a
        href="https://corp.moneyforward.com/privacy/"
        css={props.regist ? linkStyle : footerLinkStyle}
        target="_blank"
      >
        <Font variant="m" component="span">
          個人情報保護方針
          {props.regist ? (
            <>
              {" "}
              <Icon css={icon} name="openInNew" size="sm" />{" "}
            </>
          ) : null}
        </Font>
      </a>
      {props.regist ? (
        <Font variant="m" component="span">
          に同意する
        </Font>
      ) : null}
    </>
  );
};
const icon = css({
  cursor: "pointer",
  margin: "4px",
});
